import React, { memo } from 'react';
import { Link } from "@remix-run/react";
import { styled, css } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { zIndex } from '../../../../../play-core/styles/z-index';
import { usePath } from '../../../config/VideoAppContext';
import { gridChannelHeight, gridChannelWidth, gridGap, minutesPerDay, timelineRightSpace } from '../tv-guide-types';
import { GridEntry } from './GridEntry';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GridChannel = /*#__PURE__*/memo(({
  pixelsPerMinute,
  programGuide,
  activeChannelId,
  date,
  now,
  onSelectProgram,
  scrollRef,
  analyticsPageId
}) => {
  const {
    channel,
    programList
  } = programGuide;
  const {
    tvGuideByChannelPath
  } = usePath();
  return /*#__PURE__*/_jsxs(Layout, {
    pixelsPerMinutes: pixelsPerMinute,
    children: [/*#__PURE__*/_jsx(LogoContainer, {
      to: tvGuideByChannelPath(date, channel),
      children: /*#__PURE__*/_jsx(Logo, {
        "data-testclass": "channel-logo",
        alt: channel.title,
        src: channel.imageUrlRaw ?? channel.imageUrl
      })
    }), /*#__PURE__*/_jsx(List, {
      children: programList?.map(program => /*#__PURE__*/_jsx(GridEntry, {
        showImage: channel.type === 'srg',
        pixelsPerMinute: pixelsPerMinute,
        program: program,
        channel: channel,
        activeChannelId: activeChannelId,
        date: date,
        now: now,
        onSelectProgram: onSelectProgram,
        scrollRef: scrollRef,
        analyticsPageId: analyticsPageId
      }, date + program.title + program.startTime))
    })]
  });
});
const LogoContainerStyles = css(["display:flex;justify-content:center;align-items:center;background-color:", ";height:", "px;min-height:", "px;width:", "px;min-width:", "px;position:absolute;left:0;z-index:", ";"], Colors.GREY_2a2a2a, gridChannelHeight, gridChannelHeight, gridChannelWidth, gridChannelWidth, zIndex.popup);
const LogoContainer = styled(Link).withConfig({
  displayName: "GridChannel__LogoContainer",
  componentId: "sc-t4ond4-0"
})(["", ""], LogoContainerStyles);
export const LogoContainerPlaceholder = styled.div.withConfig({
  displayName: "GridChannel__LogoContainerPlaceholder",
  componentId: "sc-t4ond4-1"
})(["", ""], LogoContainerStyles);
export const List = styled.div.withConfig({
  displayName: "GridChannel__List",
  componentId: "sc-t4ond4-2"
})(["display:flex;height:", "px;min-height:", "px;padding-left:", "px;position:relative;"], gridChannelHeight, gridChannelHeight, gridChannelWidth);
export const Layout = styled.div.withConfig({
  displayName: "GridChannel__Layout",
  componentId: "sc-t4ond4-3"
})(["margin-bottom:", "px;display:flex;width:", "px;overflow:hidden;"], gridGap, ({
  pixelsPerMinutes
}) => gridChannelWidth + minutesPerDay * pixelsPerMinutes + timelineRightSpace);
const Logo = styled.img.withConfig({
  displayName: "GridChannel__Logo",
  componentId: "sc-t4ond4-4"
})(["max-height:40px;max-width:70px;height:100%;width:100%;object-fit:contain;"]);